












































































































































import Vue from 'vue'
import { convert } from './convert'

export default Vue.extend({
  name: 'Converter',

  data: () => ({
    snackbarCopy: false,
    snackbarCopyNote: 'Copied to clipboard!',
    snackbarNoInput: false,

    originalUrl: '',
    webvpnUrl: '',

    commonResources: [
      {
        name: '学工系统',
        url: 'i.xmu.edu.cn'
      },
      {
        name: '软件正版化平台',
        url: 'genuine.xmu.edu.cn'
      },
      {
        name: '中国知网',
        url: 'www.cnki.net'
      }
    ]
  }),

  methods: {
    convert (isLib = false): void {
      const originalUrl = this.originalUrl
      if (originalUrl === '') {
        this.snackbarNoInput = !this.snackbarNoInput
      } else {
        if (isLib) {
          this.webvpnUrl = this.encryptLibVPN(originalUrl)
        } else {
          this.webvpnUrl = this.encryptUrl(originalUrl)
        }
      }
    },

    encryptLibVPN (url: string): string {
      return `https://libvpn.xmu.edu.cn${convert(url)}`
    },

    encryptUrl (url: string): string {
      return `https://webvpn.xmu.edu.cn${convert(url)}`
    },

    clearInputUrl (): void {
      this.originalUrl = ''
    },

    copy (value: string): void {
      if (this.webvpnUrl === '') {
        value = 'https://webvpn.xmu.edu.cn'
        this.snackbarCopyNote = 'Default WEBVPN URL copied!'
      }
      console.log('Copied value:', value)
      // eslint-disable-next-line
      ;(this as any).$clipboard(value)
      this.snackbarCopy = !this.snackbarCopy
    }
  }
})
